import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { makeStyles, Grid, Typography } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { UNREALIZED_COLORS } from "../../constants";
import { ShaDowBox } from "../../../../components/boxes";
import { PieChart } from "../../../../components/charts";
import { NoDataCard } from "../../../../components/parts";
import { HeaderLine, LegendRows } from "./UnrealizedPieLegend";
import {
  api,
  capitalize,
  sumFromListOfObjects,
  requestDateFormat,
  currencyFormatter,
  onlyUniqueValuesOfKeyInArray,
} from "../../../../services";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
  legendBox: {
    padding: theme.spacing(2),
  },
}));

export const UnrealizedRevenuesPie = ({ period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => {
        if (!onlyUniqueValuesOfKeyInArray(resp.data.results, "value", 0)) {
          const data = resp.data.results.map((item) => ({
            name: capitalize(item.name).replaceAll("_", " "),
            value: item.value,
            displayValue: currencyFormatter(item.value, currencySymbol),
            formatType: "inline",
            key: item.name,
          }));
          setData(data);
        }
      });
    };

    const getUrl = (period) => {
      let url = "/praas/v1/unrealized/trading-assets/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
        getData(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getData(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  const getData = useMemo(() => {
    return data.filter((val) => val.value);
  }, [data]);

  return (
    <Grid item xs={12} sm={4}>
      <ShaDowBox>
        {data && data.length ? (
          <div className={classes.box} id="unrealized-revenue-piechart">
            <Typography variant="h4">Acc. Unrealized 1</Typography>
            <>
              <PieChart name="UnrealizedPowerRevenue" data={getData} colors={UNREALIZED_COLORS} />
              <div
                className={classes.legendBox}
                style={{ borderBottom: `1px dashed ${COLORS.darks[0][50]}` }}
              >
                <HeaderLine
                  title="UNREALIZED TRADING"
                  value={sumFromListOfObjects(data.slice(0, 2), "value")}
                />
                <LegendRows rows={data.slice(0, 2)} />
              </div>

              <div className={classes.legendBox}>
                <HeaderLine
                  title="UNREALIZED POWER ASSETS"
                  value={sumFromListOfObjects(data.slice(2), "value")}
                />
                <LegendRows rows={data.slice(2)} />
              </div>
            </>
          </div>
        ) : (
          <NoDataCard title="Acc. Unrealized 1" type="pie" />
        )}
      </ShaDowBox>
    </Grid>
  );
};
